exports = module.exports = require("../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filters_content {\n  width: 100%;\n  padding: 0 15px;\n  height: 190px;\n  border-bottom: solid 1px #ececec;\n  background-color: #fff;\n  position: fixed;\n  top: 60px;\n  z-index: 5;\n}", ""]);

// exports
